import React from "react";
import StatusCheckinIcon from "../../../components/StatusCheckinIcon";
import { StatusCheckinEnum } from "../../../model/Enums/StatusCheckinEnum";
import {
    StyledLegendIconContainer,
    StyledLegendIconContent,
    StyledLegendIconLabelContent,
} from "../../../styles/pages/Schedule/ScheduleStyle";

interface ILegendItemIcon {
    labels: string[];
    statusCheckin: StatusCheckinEnum;
}

const LegendItemIcon = ({
    labels,
    statusCheckin = StatusCheckinEnum.Dispensado,
}: ILegendItemIcon) => {
    const getLabels = () => {
        return (
            labels.length &&
            labels.map((label) => {
                return <p>{label}</p>;
            })
        );
    };

    return (
        <StyledLegendIconContainer>
            <StyledLegendIconContent>
                <StatusCheckinIcon status={statusCheckin} />
            </StyledLegendIconContent>
            <StyledLegendIconLabelContent>
                {getLabels()}
            </StyledLegendIconLabelContent>
        </StyledLegendIconContainer>
    );
};

export default LegendItemIcon;
